import { CountryService } from './admin/CountryService';
import { PathwayService } from './admin/PathwayService';
import { LeadService } from './admin/LeadService';
import { WizardService } from './admin/WizardService';
import { ClientService } from './admin/ClientService';
import { CaseService } from './admin/CaseService';
import { ContentService } from './admin/ContentService';
import { AuditService } from './admin/AuditService';
import { DocumentService } from './admin/DocumentService';

export class AdminService {
  // Countries
  static getCountries = CountryService.getCountries;
  static createCountry = CountryService.createCountry;
  static updateCountry = CountryService.updateCountry;
  static deleteCountry = CountryService.deleteCountry;
  static getCountriesThrottled = CountryService.getCountriesThrottled;

  // Pathways
  static getImmigrationPathways = PathwayService.getImmigrationPathways;
  static createPathwayDraft = PathwayService.createPathwayDraft;
  static getPathwayVersions = PathwayService.getPathwayVersions;
  static updatePathwayVersion = PathwayService.updatePathwayVersion;
  static publishPathwayVersion = PathwayService.publishPathwayVersion;
  static clonePathwayVersion = PathwayService.clonePathwayVersion;
  static createPathway = PathwayService.createPathway;
  static updatePathway = PathwayService.updatePathway;
  static deletePathway = PathwayService.deletePathway;
  static bulkSetPathwaysActive = PathwayService.bulkSetPathwaysActive;
  static getCostComponents = PathwayService.getCostComponents;
  static createCostComponent = PathwayService.createCostComponent;
  static updateCostComponent = PathwayService.updateCostComponent;
  static deleteCostComponent = PathwayService.deleteCostComponent;
  static getScoringCriteria = PathwayService.getScoringCriteria;
  static createScoringCriteria = PathwayService.createScoringCriteria;
  static updateScoringCriteria = PathwayService.updateScoringCriteria;
  static deleteScoringCriteria = PathwayService.deleteScoringCriteria;
  static createScoringRule = PathwayService.createScoringRule;
  static updateScoringRule = PathwayService.updateScoringRule;
  static deleteScoringRule = PathwayService.deleteScoringRule;
  static getPackages = PathwayService.getPackages;
  static createPackage = PathwayService.createPackage;
  static updatePackage = PathwayService.updatePackage;
  static deletePackage = PathwayService.deletePackage;
  static createPackagePerk = PathwayService.createPackagePerk;
  static updatePackagePerk = PathwayService.updatePackagePerk;
  static deletePackagePerk = PathwayService.deletePackagePerk;
  static getLoanOptions = PathwayService.getLoanOptions;
  static createLoanOption = PathwayService.createLoanOption;
  static updateLoanOption = PathwayService.updateLoanOption;
  static deleteLoanOption = PathwayService.deleteLoanOption;
  static getImmigrationPathwaysThrottled = PathwayService.getImmigrationPathwaysThrottled;
  static getPackagesThrottled = PathwayService.getPackagesThrottled;
  static getLoanOptionsThrottled = PathwayService.getLoanOptionsThrottled;

  // Leads (Wizard Submissions & Activities)
  static getWizardSubmissions = LeadService.getWizardSubmissions;
  static getWizardSubmission = LeadService.getWizardSubmission;
  static updateWizardSubmissionStatus = LeadService.updateWizardSubmissionStatus;
  static upsertLeadRanking = LeadService.upsertLeadRanking;
  static assignWizardSubmission = LeadService.assignWizardSubmission;
  static autoAssignStaff = LeadService.autoAssignStaff;
  static deleteWizardSubmission = LeadService.deleteWizardSubmission;
  static getWizardSubmissionsPaged = LeadService.getWizardSubmissionsPaged;
  static getLeadActivities = LeadService.getLeadActivities;
  static createLeadActivity = LeadService.createLeadActivity;
  static updateLeadActivity = LeadService.updateLeadActivity;
  static deleteLeadActivity = LeadService.deleteLeadActivity;
  static getSubmissionStats = LeadService.getSubmissionStats;
  static getWizardSubmissionsThrottled = LeadService.getWizardSubmissionsThrottled;
  static getCommunicationHistory = LeadService.getCommunicationHistory;
  static createCommunication = LeadService.createCommunication;

  // Wizard (Sessions & Analytics)
  static getWizardSessions = WizardService.getWizardSessions;
  static getWizardExitIntents = WizardService.getWizardExitIntents;
  static updateWizardFollowUp = WizardService.updateWizardFollowUp;
  static getWizardAnalytics = WizardService.getWizardAnalytics;
  static getWizardSessionsThrottled = WizardService.getWizardSessionsThrottled;

  // Clients
  static convertSubmissionToClient = ClientService.convertSubmissionToClient;
  static ensureClientPortalUser = ClientService.ensureClientPortalUser;
  static resetClientPortalPassword = ClientService.resetClientPortalPassword;

  // Cases
  static getCasesPaged = CaseService.getCasesPaged;
  static updateCase = CaseService.updateCase;
  static bulkUpdateCases = CaseService.bulkUpdateCases;
  static getPendingTasks = CaseService.getPendingTasks;
  static getUnifiedDeadlines = CaseService.getUnifiedDeadlines;
  static getDeadlineStats = CaseService.getDeadlineStats;
  static acknowledgeDeadlineAlert = CaseService.acknowledgeDeadlineAlert;
  static bulkUpdateDeadlines = CaseService.bulkUpdateDeadlines;

  // Content (Translations)
  static getTranslationCategories = ContentService.getTranslationCategories;
  static getTranslationKeys = ContentService.getTranslationKeys;
  static createTranslationKey = ContentService.createTranslationKey;
  static updateTranslation = ContentService.updateTranslation;
  static bulkUpdateTranslations = ContentService.bulkUpdateTranslations;
  static getTranslationCategoriesThrottled = ContentService.getTranslationCategoriesThrottled;

  // Audit & Stats
  static recordAuditLog = AuditService.recordAuditLog;
  static getAuditLogs = AuditService.getAuditLogs;
  static getAuditLogFilters = AuditService.getAuditLogFilters;
  static exportAuditLogsCSV = AuditService.exportAuditLogsCSV;
  static getAdminStats = AuditService.getAdminStats;

  // Documents
  static getDocumentsPaged = DocumentService.getDocumentsPaged;
}

export default AdminService;